import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import { BORDER, COLOR_GREY_4 } from "shared/theme/colors";
import { flex } from "shared/theme/mixins";

export const StyledMessageContainer = styled(Box)`
  ${flex({ fd: "row" })};
  column-gap: 0.75rem;
`;

export const StyledMessage = styled(Box, {
  shouldForwardProp: (propName) =>
    !["bgColor", "isMessageFromUser"].includes(propName),
})<{
  bgColor: string;
  isMessageFromUser: boolean;
}>`
  ${flex({ fd: "row" })};
  padding: 0.5rem 0.75rem;
  border-radius: ${({ isMessageFromUser }) =>
    isMessageFromUser ? "0 8px 8px 8px" : "8px 0px 8px 8px"};
  border: ${BORDER(1, COLOR_GREY_4)};
  background-color: ${({ bgColor }) => bgColor};
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
`;

export const StyledContainer = styled(Box, {
  shouldForwardProp: (propName) => !["isDisabled"].includes(propName),
})<{ isDisabled?: boolean }>`
  ${flex({ fd: "column" })};
  width: 100%;
  opacity: ${({ isDisabled }) => (isDisabled ? "0.4" : "1")};
`;
